export type Severity = 'note' | 'warning' | 'alert';

/**
 * Severity reaches the UI in two different wire formats, because the events
 * behind it come from two different backends: olserver (`getCurrentEvents`,
 * `getEventsForPeriod`) emits the `WDESEV_*` form, while the REST
 * eventdetector API (`getEventDetails`) emits bare lowercase
 * `note`/`warning`/`alert`. Other event families (s2s, grounding) have their
 * own services again.
 *
 * Accepting both formats is what the toast-side parsers already did; the
 * notification-list parser matched only `WDESEV_*` and quietly returned 'note'
 * for anything else. Failing closed to the *lowest* severity is the wrong
 * direction for an alerting product, so one permissive parser is used
 * everywhere instead. Unrecognised input still yields 'note' - a notification
 * of unknown severity is better than none.
 */
export const parseEventSeverity = (severity: string | undefined): Severity => {
  switch (severity?.toLowerCase()) {
    case 'wdesev_alert':
    case 'alert':
      return 'alert';
    case 'wdesev_warning':
    case 'warning':
      return 'warning';
    default:
      return 'note';
  }
};
